// ============================================================
// PruebaV2.jsx — Página temporal de verificación del Design System v2
// Ruta: /prueba-v2
// Eliminar este archivo y la ruta tras validar.
// ============================================================

import React from 'react';
import {
    Button,
    Card,
    CardHeader,
    CardTitle,
    CardDescription,
    CardContent,
    CardFooter,
    KpiCard,
    Avatar,
    Badge,
} from './assets/componentes/ui';
import { Phone, TrendingUp, Users } from 'lucide-react';

const PruebaV2 = () => (
    <div className="min-h-screen p-8" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>
        <div className="max-w-4xl mx-auto space-y-8">

            <header>
                <div className="text-xs uppercase tracking-widest font-semibold mb-2"
                     style={{ color: 'hsl(var(--brand-light))' }}>
                    Design System v2
                </div>
                <h1 className="text-2xl font-semibold text-slate-900">Prueba visual de componentes</h1>
                <p className="text-sm text-slate-500 mt-1">
                    Verificación rápida de Button, Card, KpiCard, Avatar y Badge.
                </p>
            </header>

            {/* BOTONES */}
            <section>
                <h2 className="text-sm font-semibold text-slate-700 mb-3">Botones</h2>
                <div className="flex flex-wrap gap-3">
                    <Button variant="primary">Primary</Button>
                    <Button variant="outline">Outline</Button>
                    <Button variant="ghost">Ghost</Button>
                    <Button variant="danger">Danger</Button>
                </div>
            </section>

            {/* CARD */}
            <section>
                <h2 className="text-sm font-semibold text-slate-700 mb-3">Card</h2>
                <Card>
                    <CardHeader>
                        <CardTitle>Tarjeta de ejemplo</CardTitle>
                        <CardDescription>Borde sutil, sin sombras pesadas.</CardDescription>
                    </CardHeader>
                    <CardContent>
                        <p className="text-sm text-slate-600">
                            Este es el contenido principal de la tarjeta. La densidad y los paddings
                            son consistentes con el resto del Design System v2.
                        </p>
                    </CardContent>
                    <CardFooter>
                        <Button size="sm" variant="outline">Acción secundaria</Button>
                    </CardFooter>
                </Card>
            </section>

            {/* KPI CARDS */}
            <section>
                <h2 className="text-sm font-semibold text-slate-700 mb-3">KpiCards</h2>
                <div className="grid grid-cols-2 gap-4">
                    <KpiCard
                        label="Total llamadas"
                        value="70.895"
                        icon={<Phone className="size-3.5" />}
                        trend={{ direction: 'up', label: '12,4% vs periodo anterior' }}
                    />
                    <KpiCard
                        label="Equipo activo"
                        value="32"
                        icon={<Users className="size-3.5" />}
                        subtitle="Teleoperadoras dadas de alta"
                        progress={75}
                    />
                </div>
            </section>

            {/* AVATARES */}
            <section>
                <h2 className="text-sm font-semibold text-slate-700 mb-3">Avatares</h2>
                <div className="flex items-center gap-3">
                    <Avatar name="Iban Lopetegi" size="md" />
                    <Avatar name="María López" size="md" />
                    <Avatar name="Alma Alvarez" size="lg" />
                    <span className="text-xs text-slate-500 ml-2">
                        El color se deriva del nombre — siempre es el mismo para la misma persona.
                    </span>
                </div>
            </section>

            {/* BADGES */}
            <section>
                <h2 className="text-sm font-semibold text-slate-700 mb-3">Badges</h2>
                <div className="flex flex-wrap items-center gap-2">
                    <Badge variant="success">Aprobado</Badge>
                    <Badge variant="warning">Cambio pendiente</Badge>
                    <Badge variant="danger">Rechazado</Badge>
                    <Badge variant="info">Info</Badge>
                    <Badge variant="primary">Activo</Badge>
                    <Badge variant="secondary">Neutro</Badge>
                </div>
            </section>

            <footer className="text-[11px] text-slate-400 pt-6 border-t">
                Si ves bordes sutiles, tipografía Inter, azul corporativo #0066b3 y radius generosos,
                el DS v2 está correctamente integrado. <TrendingUp className="inline size-3 align-text-bottom" />
            </footer>
        </div>
    </div>
);

export default PruebaV2;
